import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogActions, useTheme } from "@mui/material";
import { HeaderButton } from "../buttons/HeaderButton";
import { useAuth } from "../../contexts";

export const LogoutDialog = (props) => {
  const { open, onClose } = props;
  const theme = useTheme();
  const { logout } = useAuth();

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { p: 2 },
        elevation: 0,
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 24,
          fontWeight: 700,
          textAlign: "center",
        }}
      >
        Are you sure you want to logout?
      </DialogTitle>
      <DialogActions sx={{ pb: 2, justifyContent: "center", gap: 2 }}>
        <HeaderButton type="secondary" onClick={onClose}>
          Cancel
        </HeaderButton>
        <HeaderButton type="primary" onClick={() => logout()}>
          Logout
        </HeaderButton>
      </DialogActions>
    </Dialog>
  );
};

LogoutDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
